import script from "./ToolbarDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolbarDropdown.vue?vue&type=script&setup=true&lang=js"

import "./ToolbarDropdown.vue?vue&type=style&index=0&id=7d10965c&lang=css"

const __exports__ = script;

export default __exports__